import React, { useContext } from 'react';
import { AppContext } from '../context/appData';

const Loader = props => {
  const appData = useContext(AppContext);
  return (
    <div className={`app__loader ${props.fixed ? 'fixed' : ''}`}>
      <div className="lds-ellipsis">
        {[...Array(4).keys()].map((_, i) => {
          return (
            <div
              key={i}
              style={{
                background: props.color || appData.theme.color || '#015fd1',
              }}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

export default Loader;
